<app-bar-chart
  chartId="myDaySpotchart-new"
  [dataSets]="dataSets"
  [labels]="labels"
  [title]="title"
  [tooltipCallbacks]="tooltipCallbacks"
  [xUnit]="'day'"
  [yUnit]="'øre/kWh'"
  [showLegend]="showLegend"
  [showYTitle]="showYTitle"
  [annotations]="annotations"
></app-bar-chart>
